import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import * as _ from "lodash";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const ModelCoefficientSearch: ISearch = {
    searchName: "Find Model Coefficient",
    renderOptions: {ui5ResourceId: "ModelCoefficientSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
};

const vUI_Model_Coefficient_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODEL_COEFFICIENT_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Model Coefficient Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    MODEL_COEFFICIENT_ID:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Coefficient Id',            columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_COEFFICIENT_NAME:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Coefficient Name',          columnResourceName: 'colModelName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelCoefficientSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_MODEL_COEFFICIENT_ID',
        id_ui: 'MODEL_COEFFICIENT_ID',
        name:  'MODEL_COEFFICIENT_NAME'
    },

    searchProviderFields: vUI_Model_Coefficient_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Coefficient_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Model_Coefficient_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
};

const ModelCoefficientSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ModelCoefficientSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_COEFFICIENT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_COEFFICIENT_NAME', renderOptions: {}},
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_COEFFICIENT_ID', 'MODEL_COEFFICIENT_NAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelCoefficientSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

ModelCoefficientSearch.searchProfiles = [ModelCoefficientSearchProfileByName]

PAEnvironment.registerBusinessObjectSearch("ModelCoefficientBO", "ModelCoefficient", ModelCoefficientSearch, "Model Coefficient Search")


export {ModelCoefficientSearch}